"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.scrape = void 0;
const FetchHelper_1 = __importDefault(require("../helpers/FetchHelper"));
async function scrape(vendorId, blob, user, scraperBaseUrl) {
    // form data
    const formData = new FormData();
    formData.append('vendorId', vendorId);
    formData.append('pdf', blob);
    // request
    const response = await FetchHelper_1.default.fetch(`${scraperBaseUrl}/any`, {
        method: 'POST',
        body: formData,
        headers: await FetchHelper_1.default.firebaseAuthorization(user),
    });
    // get result
    return (await response.json());
}
exports.scrape = scrape;
// export function scraperForVendorId(
//   vendorId: string,
//   environment: Environment,
// ): ((blob: Blob, user: User, waveApiUrl: string) => Promise<Trip[]>) | undefined {
//   switch (vendorId) {
//     case vendorIdGrecianGyro(environment):
//       return scraperFetchGrecianGryo;
//     case vendorIdLemonade(environment):
//       return scraperFetchLemonade;
//     case vendorIdModernMarket(environment):
//       return scraperFetchModernMarket;
//     case vendorIdPomella(environment):
//       return scraperFetchPomella;
//     case vendorIdSalsaritas(environment):
//       return scraperFetchSalsaritas;
//     default:
//       return undefined;
//     // throw new Error(`Can't find scraper function for vendor ${vendorId}`);
//   }
// }
// export async function scraperFetchGrecianGryo(blob: Blob, user: User, waveApiUrl: string): Promise<Trip[]> {
//   const formData = new FormData();
//   formData.append('pdf', blob);
//   const response = await FetchHelper.fetch(`${waveApiUrl}/scraper/grecian`, {
//     method: 'POST',
//     body: formData,
//     headers: await FetchHelper.firebaseAuthorization(user),
//   });
//   const json = (await response.json()) as never as any[];
//   json;
//   return undefined as never as Trip[];
// }
// export async function scraperFetchLemonade(blob: Blob, user: User, waveApiUrl: string): Promise<Trip[]> {
//   const formData = new FormData();
//   formData.append('pdf', blob);
//   const response = await FetchHelper.fetch(`${waveApiUrl}/scraper/lemonade`, {
//     method: 'POST',
//     body: formData,
//     headers: await FetchHelper.firebaseAuthorization(user),
//   });
//   const json = (await response.json()) as never as any[];
//   json;
//   return undefined as never as Trip[];
// }
// export async function scraperFetchModernMarket(blob: Blob, user: User, waveApiUrl: string): Promise<Trip[]> {
//   const formData = new FormData();
//   formData.append('pdf', blob);
//   const response = await FetchHelper.fetch(`${waveApiUrl}/scraper/lemonade`, {
//     method: 'POST',
//     body: formData,
//     headers: await FetchHelper.firebaseAuthorization(user),
//   });
//   const json = (await response.json()) as never as any[];
//   json;
//   return undefined as never as Trip[];
// }
// export async function scraperFetchPomella(blob: Blob, user: User, waveApiUrl: string): Promise<Trip[]> {
//   const formData = new FormData();
//   formData.append('pdf', blob);
//   const response = await FetchHelper.fetch(`${waveApiUrl}/scraper/pomella`, {
//     method: 'POST',
//     body: formData,
//     headers: await FetchHelper.firebaseAuthorization(user),
//   });
//   const json = (await response.json()) as never as any[];
//   console.log(json);
//   return tripFromPomellaInvoice(json, googleMapsApiOptions)
//   return undefined as never as Trip[];
// }
// export async function scraperFetchSalsaritas(blob: Blob, user: User, waveApiUrl: string): Promise<Trip[]> {
//   const formData = new FormData();
//   formData.append('pdf', blob);
//   const response = await FetchHelper.fetch(`${waveApiUrl}/scraper/salsarita`, {
//     method: 'POST',
//     body: formData,
//     headers: await FetchHelper.firebaseAuthorization(user),
//   });
//   const json = (await response.json()) as never as any[];
//   json;
//   return undefined as never as Trip[];
// }
